import React from 'react';
import TeamAssessments from '../../components/team/TeamAssessments';

const TeamAssessmentsPage = ({ employees }) => {
  return <TeamAssessments employees={employees} />;
};

export default TeamAssessmentsPage;
